import type { Offer, OfferType } from '@makemydeal/dr-platform-types';
import { FINANCE } from '@makemydeal/dr-platform-types';
import type { PartialPenciledInputsWithAllTypes, PenciledInputsState } from '../../../types/commonTypes';
import {
    UPDATED_BALLOON_PAYMENT_AMOUNT,
    UPDATED_BALLOON_TYPE,
    REVERT_BALLOON_DEAL_TO_BASE_FINANCE
} from '../../../types/actionTypes';
import { updateInputWithValue, updateOfferTypeWithInputs } from '../helpers';

export const handleBalloonCases = (
    state: PenciledInputsState,
    action: any,
    offerType: OfferType,
    _offer: Offer,
    isUserProgramQuotes: boolean
): PartialPenciledInputsWithAllTypes => {
    switch (action.type) {
        case UPDATED_BALLOON_PAYMENT_AMOUNT: {
            const balloonPaymentAmount = action.payload;
            if (!state.byOfferType) return state;

            if (isUserProgramQuotes) {
                const newState = {
                    ...state,
                    byOfferType: {
                        ...state.byOfferType,
                        [offerType]: {
                            ...state.byOfferType?.[offerType],
                            balloonPaymentAmountOverride: balloonPaymentAmount
                        }
                    }
                };
                return newState;
            }

            const balloonPaymentUpdates = updateOfferTypeWithInputs(
                state.byOfferType,
                updateInputWithValue(state.byOfferType?.[offerType], 'balloonPaymentAmountOverride', balloonPaymentAmount),
                offerType
            );

            return {
                ...state,
                byOfferType: balloonPaymentUpdates
            };
        }

        case UPDATED_BALLOON_TYPE: {
            const balloonType = action.payload;
            if (!state.byOfferType) return state;

            if (isUserProgramQuotes) {
                const newState = {
                    ...state,
                    byOfferType: {
                        ...state.byOfferType,
                        [offerType]: {
                            ...state.byOfferType?.[offerType],
                            balloonTypeOverride: balloonType
                        }
                    }
                };
                return newState;
            }

            const balloonTypeUpdates = updateOfferTypeWithInputs(
                state.byOfferType,
                updateInputWithValue(state.byOfferType?.[offerType], 'balloonTypeOverride', balloonType),
                offerType
            );

            return {
                ...state,
                byOfferType: balloonTypeUpdates
            };
        }

        case REVERT_BALLOON_DEAL_TO_BASE_FINANCE: {
            if (!state.byOfferType) return state;

            const balloonInputs = state.byOfferType.balloon;
            const financeInputs = state.byOfferType[FINANCE];

            const rateOverrides = {
                ...(balloonInputs?.sellRateOverride != null && { sellRateOverride: balloonInputs.sellRateOverride }),
                ...(balloonInputs?.buyRateOverride != null && { buyRateOverride: balloonInputs.buyRateOverride }),
                ...(balloonInputs?.rateTypeOverride != null && { rateTypeOverride: balloonInputs.rateTypeOverride }),
                ...(balloonInputs?.overridesByTerm != null && { overridesByTerm: balloonInputs.overridesByTerm }),
                ...(balloonInputs?.term != null && { term: balloonInputs.term })
            };

            if (Object.keys(rateOverrides).length === 0) {
                return state;
            }

            return {
                ...state,
                byOfferType: {
                    ...state.byOfferType,
                    [FINANCE]: {
                        ...financeInputs,
                        ...rateOverrides
                    }
                }
            };
        }

        default:
            return state;
    }
};
